import React from 'react';
import { replace } from 'react-router-redux';

import {ROUTE_ZIPS} from '../../../constants/routeconstants';
import { connect } from 'react-redux';
import UserRoles from "../../../../../common/src/enums/UserRoles";
import {Link} from "react-router";
import * as AdminActions from "../../../actions/admin";
import {confirm} from "../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "../../reusable/UserFieldElement";
import moment from "moment";
import config from "../../../../../server/src/config";
import {nullToBlank} from "../../../../../common/src/util/lib";

class ZipCodesPage extends React.Component {

    static getId() {
        return ROUTE_ZIPS;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            editId: null,
            filter: '',
            sort: 'Postnr',
        };
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getListItems('postnr'));
    }

    fields = [];

    render() {
        return this.props.zipCodes ? <div>
            <div className="sub-page-title">
                <h2>Postnumre</h2>
            </div>
            <div id="sub-page-content" className="sub-page-content">
                <table className="data-table">
                    <thead>
                    <tr>
                        <th scope="row" className={this.state.editId === null ? "clickable" : ""} onClick={() => {if (this.state.editId === null) this.setState({sort: 'Postnr'})}}>Postnummer</th>
                        <th className={this.state.editId === null ? "clickable" : ""} onClick={() => {if (this.state.editId === null) this.setState({sort: 'By'})}}>By</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.zipCodes
                        .filter(p => this.state.filter === '' ? true :
                            nullToBlank(p.Postnr).toUpperCase().search(this.state.filter) >= 0 ||
                            nullToBlank(p.By).toUpperCase().search(this.state.filter) >= 0
                        )
                        .sort((p1, p2) => {
                            if (p1.Postnr === '') return 1;
                            if (p2.Postnr === '') return -1;
                            const comp = (p1[this.state.sort] === null ? '' : p1[this.state.sort].trim()).localeCompare(p2[this.state.sort] === null ? '' : p2[this.state.sort].trim(), 'da-DK');
                            return comp === 0 ? (p1.Postnr < p2.Postnr ? -1 : p1.Postnr > p2.Postnr ? 1 : 0) : comp;
                        })
                        .toArray().concat(this.state.editId === 'new' ? [this.state] : []).map(zipCodeObj => {
                            return this.state.editId === null || (zipCodeObj.Postnr !== this.state.editId && typeof(zipCodeObj.editId) === 'undefined') ? <tr key={zipCodeObj.Postnr} id={'row-' + zipCodeObj.Postnr}>
                                <th scope="row">{zipCodeObj.Postnr}</th>
                                <td>{zipCodeObj.By}</td>
                                <td className="commands-column">
                                    <i className={"fa fa-pencil " + (this.state.editId === null ? 'clickable' : 'disabled')} title="Rediger postnummer" onClick={() => {
                                        if (this.state.editId === null) this.setState({
                                            editId: zipCodeObj.Postnr,
                                            Postnr: zipCodeObj.Postnr,
                                            By: zipCodeObj.By === null ? '' : zipCodeObj.By,
                                        });
                                    }}/>
                                    <i className={"fa fa-trash " + (this.state.editId === null ? 'clickable' : 'disabled')} title="Slet postnummer" onClick={() => {
                                        if (this.state.editId === null) confirm("Slet", <span>Ønsker du at slette postnummeret <b>{zipCodeObj.Postnr} ({zipCodeObj.By})</b>?</span>, () => {
                                            this.props.dispatch(AdminActions.deleteListItem('postnr', zipCodeObj.Postnr, () => {
                                                NotificationManager.success("Postnummeret " + zipCodeObj.Postnr + " (" + zipCodeObj.By + ") er slettet.", "Sletning", 4000);
                                            }));
                                        });
                                    }}/>
                                </td>
                            </tr> : <tr key="editor" id="row-editor" className="edit-row">
                                <th>
                                    <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field60" containerClassName="display-inline-block"
                                                      name="Postnr" id="Postnr" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{4}"}]} value={this.state.Postnr}
                                                      autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                        //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[0] = instance; }}
                                    />
                                </th>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="" containerClassName=""
                                                      name="By" id="By" maxLength="25" value={this.state.By}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[1] = instance; }}
                                    />
                                </td>

                                <td className="commands-column">
                                    <i className="fa fa-save clickable" title="Gem postnummer" onClick={() => {
                                        this.save();
                                    }}/>
                                    <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                                        this.setState({editId: null});
                                    }}/>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            <div className="sub-page-actions">
                <button className={"btn-primary" + (this.state.editId === null ? '' : ' disabled')} title="Opret ny postnummer" onClick = {() => {
                    if (this.state.editId === null) {
                        this.setState({
                            editId: 'new',
                            Postnr: '',
                            By: '',
                        });
                        setTimeout(function () {
                            const content = document.getElementById("sub-page-content");
                            content.scrollTop = content.scrollHeight;
                        });
                    }
                }}>Ny</button>
                <label htmlFor="filter" className={this.state.editId === null ? "" : "disabled"}>Filter</label>
                <UserFieldElement dataType={UserFieldDataType.string} placeholder="Indtast søgeværdi" className="field-1 large-field"
                                  name="filter" id="filter" disabled={this.state.editId !== null}
                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                  onChange={(e) => {
                                      const val = e.target.value.toUpperCase();
                                      //this.onStandardFieldChange(e);
                                      if (this.timeoutHandler !== null) clearTimeout(this.timeoutHandler);
                                      this.timeoutHandler = setTimeout(() => {
                                          this.setState({filter: val});
                                      }, 500);
                                  }}
                />
                <label htmlFor="sort" className={this.state.editId === null ? "" : "disabled"}>Sortering</label>
                <UserFieldElement dataType={UserFieldDataType.enum} placeholder="false" className="field-1 large-field"
                                  name="sort" id="sort"  disabled={this.state.editId !== null} value={this.state.sort} options={[
                                    {key: 'Postnr', value: 'Postnr'},
                                    {key: 'By', value: 'By'},
                                  ]}
                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                  onChange={this.onStandardFieldChange}
                />
            </div>
        </div> : null;
    }

    timeoutHandler = null;

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = () => {
        if (this.allInputValid()) {
            const Postnr = this.state.Postnr;
            const entity = {
                Postnr: this.state.Postnr,
                By: this.state.By === '' ? null : this.state.By,
            };
            if (this.state.editId === 'new') this.props.dispatch(AdminActions.createListItemItem('postnr', entity, id => {
                NotificationManager.success("Postnummeret " + id + " (" + this.state.By + ") er oprettet.", "Oprettelse", 4000);
                this.setState({editId: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + Postnr);
                    currentRow.scrollIntoView(false);
                });
            }));
            else this.props.dispatch(AdminActions.updateListItem('postnr', this.state.editId, entity, id => {
                NotificationManager.success("Postnummeret " + id + " (" + this.state.By + ") er opdateret.", "Opdatering", 4000);
                this.setState({editId: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + Postnr);
                    currentRow.scrollIntoView(false);
                });
            }));
        }  else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    zipCodes: state.admin.zipCodes,
});

export default connect(mapStateToProps)(ZipCodesPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/lists/ZipCodesPage.js